import React from 'react'
import PropTypes from 'prop-types'
import styles from './membership-checkout.scss'
import Button from 'src/components/common/Button'
import {
  buildCheckoutURLForPlans,
  getActivePlans,
  PlanType, storeUTMDataByKey, STRIPE_CHECKOUT_TIMEOUT
} from 'src/services/stripe_checkout_configs'
import CheckoutFrame from '../components/CheckoutFrame'
import MembershipPlanItem from '../components/MembershipPlanItem'
import LeftChevron from '../../../assets/icons/left_chevron.svg'
import SvgIcon from '../../../components/common/SvgIcon'
import GreenCrown from 'src/assets/icons/crown-ico-green.svg'
import PurpleCrown from 'src/assets/icons/crown-ico-purple.svg'

import {
  clearCheckoutPendingResultNode,
  PurchaseWorkflowNode, setCheckoutModalOpen,
  setCheckoutPendingResultNode, setDefaultWorkflowNode,
  setOpenedTabReference,
  setStripeCheckoutTimeoutHandle
} from 'src/actions/stripeCheckout'
import { isDevMod } from '../../../services/utils'
import { connect } from 'react-redux'
import uuid from 'uuid'

class MembershipCheckout extends React.Component {
  plans = []

  constructor(props) {
    super(props)

    const { user, currentSub } = this.props
    const isFreeTrailUsed = !user?.is_trial_available

    this.plans = getActivePlans()

    this.state = {
      selectedPlan: this.plans[0],
      isFreeTrailUsed,
      planSlug: currentSub.plan.slug,
      planSubscriptionPeriod: currentSub.plan.subscription_period
    }
  }

  openStripeCheckoutTab() {
    const { currentSub } = this.props

    const utmCode = uuid.v4()
    storeUTMDataByKey(currentSub, utmCode)
    const href = buildCheckoutURLForPlans(this.state.selectedPlan, this.state.isFreeTrailUsed, this.props.user.id, utmCode)
    const newTabRef = window.open(href, '_blank')
    this.props.setOpenedTabRef(newTabRef)
  }

  render() {
    const { setTimeoutHandle, storePendingResultNode, clearCheckoutPendingResultNode, setModalOpen, setDefaultCheckoutNode } = this.props

    const essentialPlans = this.plans.filter(p => p.planType === PlanType.Essentials)
    const premiumPlans = this.plans.filter(p => p.planType === PlanType.Premium)
    const planGroups = [
      {
        title: 'Essentials',
        items: essentialPlans
      },
      {
        title: 'Premium',
        items: premiumPlans
      }
    ]

    const devMod = isDevMod()

    return (
      <CheckoutFrame
        left={<main>
          <header className={styles['go-back']}>
            {this.props.showGoBack && <SvgIcon
              icon={LeftChevron}
              divClassName={styles['go-back-icon']}
              width={18}
              height={18}
              onClick={() => {
                this.props.onGoBack()
              }}
            />}
            <h1>{this.state.isFreeTrailUsed ? 'Subscribe' : 'Redeem Your Free Week' }</h1>
          </header>
          {planGroups.map((group, planIndex) => {
            return (
              <section className={styles['step-2']} key={planIndex}>
                <div className={styles['membership-plans']}>
                  <header className={styles['plan-header']}>
                    <SvgIcon
                      icon={group.title === 'Essentials' ? GreenCrown : PurpleCrown}
                      width={24}
                      height={24}
                    />
                    <h1>{group.title}</h1>
                  </header>
                  <section className={styles['plan-items']}>
                    {group.items.map((plan, itemIndex) => {
                    const isSelectedPlan = plan.stripeId === this.state.selectedPlan.stripeId
                      return <MembershipPlanItem
                        key={itemIndex}
                        plan={plan}
                        isSelected={isSelectedPlan}
                        onClick={(selectedPlan) => {
                          this.setState({ selectedPlan })
                        }}
                        isFreeTrailUsed={this.state.isFreeTrailUsed}
                        theme={group.title === 'Essentials' ? 'green' : 'purple'}
                      />
                  })}
                  </section>
                </div>
              </section>
            )
          })}
          <div className={styles['subscribe-btn-container']}>
            <Button className={styles['subscribe-btn']} purple={this.state.selectedPlan.planType === PlanType.Premium} onClick={() => {
              this.openStripeCheckoutTab()
              const nextNode = PurchaseWorkflowNode.PendingMembershipPaymentResult
              storePendingResultNode(nextNode)
              setModalOpen(false)
              const handle = setTimeout(() => {
                clearCheckoutPendingResultNode()
                setDefaultCheckoutNode(nextNode)
                setModalOpen(true)
              }, STRIPE_CHECKOUT_TIMEOUT)
              setTimeoutHandle(handle)
            }}>
              {this.state.selectedPlan.trialCheckoutInfo && !this.state.isFreeTrailUsed ? 'Redeem Your Free Week' : 'Subscribe'}
            </Button>
          </div>
          <div className={styles['no-benefit']}>
            <span onClick={() => {
              this.props.goToCheckoutNode(PurchaseWorkflowNode.NoMembershipFromPurchasePlan)
              }}>No membership benefits</span>
          </div>
          {devMod && <Button onClick={() => {
            this.props.goToCheckoutNode(PurchaseWorkflowNode.TestSubs)
          }}>test subs</Button>}
        </main>}
        right={<>
          {this.state.selectedPlan.detailDescriptionComp()}
        </>}
      />
    )
  }
}

MembershipCheckout.propTypes = {
  user: PropTypes.object,
  currentSub: PropTypes.object,
  goToCheckoutNode: PropTypes.func,
  onGoBack: PropTypes.func,
  showGoBack: PropTypes.bool,
  setTimeoutHandle: PropTypes.func,
  storePendingResultNode: PropTypes.func,
  clearCheckoutPendingResultNode: PropTypes.func,
  setModalOpen: PropTypes.func,
  setDefaultCheckoutNode: PropTypes.func,
  setOpenedTabRef: PropTypes.func
}

const mapDispatchToProps = (dispatch) => {
  return {
    setOpenedTabRef: (tabRef) => {
      dispatch(setOpenedTabReference(tabRef))
    },
    setTimeoutHandle: (handle) => {
      dispatch(setStripeCheckoutTimeoutHandle(handle))
    },
    storePendingResultNode: (pendingResultNode) => {
      dispatch(setCheckoutPendingResultNode(pendingResultNode))
    },
    clearCheckoutPendingResultNode: () => {
      dispatch(clearCheckoutPendingResultNode())
    },
    setModalOpen: (isOpen) => dispatch(setCheckoutModalOpen(isOpen)),
    setDefaultCheckoutNode: (node) => {
      dispatch(setDefaultWorkflowNode(node))
    }
  }
}

export default connect(null, mapDispatchToProps)(MembershipCheckout)
